import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { confirmUser } from '../actions/userActions'
import Message from '../components/Message'
import Loader from '../components/Loader'

const ConfirmationScreen = () => {
    const {token} = useParams();
    const dispatch = useDispatch()

    const userConfirmation =useSelector((state) => state.userConfirmation)
    const { loading, error} = userConfirmation

    useEffect(() => {
      dispatch(confirmUser(token))
    }, [dispatch, token]);

    const headingRef = useRef(null);

    useEffect(() => {
      if (!loading && !error && headingRef.current) headingRef.current.focus();
    }, [loading, error]);

    // Hard force LIGHT theme + hide header & all interactive elements while this screen is mounted
    useEffect(() => {
      const styleId = 'confirm-hard-light-style';
      let styleEl = document.getElementById(styleId);
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = styleId;
        styleEl.textContent = `
:root.confirm-hard-light, :root.confirm-hard-light body {\n  color-scheme: light !important;\n  --bs-body-bg:#ffffff;\n  --bs-body-color:#212529;\n  --bs-card-bg:#ffffff;\n  --bs-card-color:#212529;\n  --bs-border-color:rgba(0,0,0,.12);\n  background:linear-gradient(180deg,#f8fafc 0%,#f1f5f9 100%) !important;\n  color:var(--bs-body-color) !important;\n}\n:root.confirm-hard-light header, :root.confirm-hard-light header * { display:none !important; }\n:root.confirm-hard-light footer, :root.confirm-hard-light footer * { display:none !important; }\n:root.confirm-hard-light nav, :root.confirm-hard-light nav * { display:none !important; }\n/* Hide ALL links & buttons */\n:root.confirm-hard-light a,\n:root.confirm-hard-light [role=link],\n:root.confirm-hard-light button,\n:root.confirm-hard-light [role=button],\n:root.confirm-hard-light .btn,\n:root.confirm-hard-light input[type=button],\n:root.confirm-hard-light input[type=submit],\n:root.confirm-hard-light input[type=reset] { display:none !important; }\n:root.confirm-hard-light .card { background:var(--bs-card-bg) !important; color:var(--bs-card-color) !important; border:1px solid var(--bs-border-color) !important; box-shadow:0 8px 28px rgba(0,0,0,.08) !important; }\n:root.confirm-hard-light .text-muted { color:#5f6b76 !important; }\n`; 
        document.head.appendChild(styleEl);
      }
      const root = document.documentElement;
      const prevTheme = root.getAttribute('data-theme');
      const prevBsTheme = root.getAttribute('data-bs-theme');
      root.classList.add('confirm-hard-light');
      root.setAttribute('data-theme', 'light');
      root.setAttribute('data-bs-theme', 'light');
      return () => {
        const existing = document.getElementById(styleId);
        if (existing) existing.remove();
        root.classList.remove('confirm-hard-light');
        if (prevTheme) root.setAttribute('data-theme', prevTheme); else root.removeAttribute('data-theme');
        if (prevBsTheme) root.setAttribute('data-bs-theme', prevBsTheme); else root.removeAttribute('data-bs-theme');
      };
    }, []);

    return (
        <>
        <div className='confirm-topbar' style={{ position:'fixed', top:0, left:0, right:0, background:'#209bff', color:'#fff', textAlign:'center', padding:'.85rem 1rem', fontWeight:600, fontSize:'1.15rem', letterSpacing:'.5px', zIndex:999 }}>LOTUSTOR</div>
        <div className='confirm-screen-standalone container py-5' style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', paddingTop:'4.2rem' }}>
          <div className='row justify-content-center w-100'>
            <div className='col-md-8 col-lg-6'>
              {loading ? (
                <Loader />
              ) : error ? (
                <Message variant='danger'>{error}</Message>
              ) : (
                <div className='card shadow-sm border-0'>
                  <div className='card-body text-center' role='status' aria-live='polite'>
                    <span className='badge bg-success mb-3' style={{ fontSize: '1.75rem', lineHeight: 1.1, padding: '.75rem 1.1rem', borderRadius: '1rem', fontWeight: 600 }}>Email Confirmed</span>
                    <h1 ref={headingRef} tabIndex='-1' className='h3 fw-semibold mb-3'>Thank you for confirming your email!</h1>
                    <p className='text-muted mb-0'>Your account is now active. You may close this window and log in from the main site navigation.</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        </>
    )
}

export default ConfirmationScreen